import React from "react";
import injectSheet from "react-jss";
import { FallbackStyle as Style } from "./style";

const LazyLoadedModuleFallback = ({ classes }) => (
  <div className={classes.spinner} />
);

export default injectSheet(Style)(LazyLoadedModuleFallback);
